import { createFileRoute } from "@tanstack/react-router";
import SaintDepressionFlyer from "@/pages/SaintDepressionFlyer";

const URL = "https://neurowellnesstms.com/saint-depression-flyer";

// Kept live for the printed flyer QR code / webinar audience, but
// noindex + removed from the sitemap so it can't compete with
// /learn/what-is-saint-tms in Google.
export const Route = createFileRoute("/saint-depression-flyer")({
  head: () => ({
    meta: [
      { name: "robots", content: "noindex, follow" },
      { title: "What Is SAINT Depression Treatment? | Neuro Wellness" },
      {
        name: "description",
        content:
          "SAINT is an FDA-cleared, 5-day accelerated TMS protocol using fMRI-guided targeting for treatment-resistant depression. See how it works in Coral Springs, FL.",
      },
      {
        property: "og:title",
        content: "What Is SAINT Depression Treatment? | Neuro Wellness",
      },
      { property: "og:url", content: URL },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: URL }],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <SaintDepressionFlyer />;
}
